import React, {useContext, useState} from 'react';
import {Col, Container, Form, FormControl, InputGroup, Modal, Row} from "react-bootstrap";
import {VALIDATION_IN_JS} from "../../utils/Constants";
import { WEB_ANNOUNCEMENTS_CREATE_URL} from "../../service/UrlConstant";
import {SecurityContext} from "../../context/security";
import {ToastContext} from "../../context/Toast";


export default function CreateAnnouncementModal(props) {
    const [createAnnouncement, setCreateAnnouncement] = useState({header: '', content: '', notification: ''})
    const [formErrors, setFormErrors] = useState({})
    const {makePostRequest} = useContext(SecurityContext);
    const {success, error} = useContext(ToastContext);

    const handleCreateClose = () =>{
        props.setShow(false);
        props.setShowCreate(false);
    }

    const getNewRowNumber = ()=>{
        if(props.announcements && props.announcements.length > 0) {
            const maxRowNumber = Math.max(...props.announcements.map(announcement => announcement.position));
            return maxRowNumber + 1;
        }
        return 1;
    }

    const handleOnChange = (e)=>{
        const {name, value, type, checked} = e.target;
        setCreateAnnouncement((prevState)=>({
            ...prevState,
            [name]:type === 'checkbox' ? checked : value,
        }))
        setFormErrors(prevFormErrors=>{
            const {[name]: _, ...otherFormErrors} = prevFormErrors;
            return otherFormErrors;
        })
    }

    const createAnnouncementHandler = (e)=>{
        e.preventDefault();
        let errors = {}
        if (VALIDATION_IN_JS) {
            errors = props.validateSubmission(formErrors, createAnnouncement);
        }

        setFormErrors(errors);

        if(Object.keys(errors) != 0)
            return

        const onSuccess = (response) => {
            success('Announcement created successfully!')
            props.setShow(false)
            props.setShowCreate(false)
            if(response.data) {
                const updatedAnnouncements = [...props.announcements, response.data];
                props.setAnnouncements(updatedAnnouncements);
            }

        }
        const onError = (err) => {
            error('Error creating announcement')
            console.error(err);
        }

        const newRowNumber = getNewRowNumber();
        const createParams = {
            header: createAnnouncement.notification === 'Alert'? `ALERT: ${createAnnouncement.header}`:
                createAnnouncement.header,
            content: createAnnouncement.content,
            position: newRowNumber,
            isCanceled: 'N',
            version: 0,
        }

        makePostRequest(createParams, WEB_ANNOUNCEMENTS_CREATE_URL, onSuccess, onError)

    }


    return  <Modal
                show={props.show &&  props.showCreate}
                onHide={handleCreateClose}
                animation={false}
                className='pb-0'
                id='create-modal'
                backdrop='static'>
                <Modal.Header closeButton
                              style={{textAlign: 'right', border:'none', alignSelf:'flex-end'}} className='pb-0'>
                </Modal.Header>
                <Container className="mt-md-3 mt-sm-0 pb-4 pt-0">
                    <Form className={'mt-0'} onSubmit={(e) => createAnnouncementHandler(e)} >
                        <Col>
                            <h2 className='mb-4'>Creation New Notification</h2>
                        </Col>
                        <Col xs={12} sm={12} md={12} className={'py-0'}>
                            <Form.Group controlId="formGridSecurity">
                                <label className='my-0'>Header *</label>
                                <InputGroup>
                                    <FormControl
                                        className='pl-3 rounded'
                                        as="textarea"
                                        placeholder="Enter Alert or Notification Header"
                                        value={createAnnouncement.header}
                                        name='header'
                                        onChange={handleOnChange}
                                        isInvalid={!!formErrors.header}
                                        style={{
                                            height:'70px',
                                            fontSize: '16px',
                                            fontWeight: 'light',
                                            fontFamily : 'TD Graphik SemiLight'
                                        }}

                                    />
                                    <Form.Control.Feedback type={"invalid"}>
                                        <b>
                                            <i className="bi bi-exclamation-circle">
                                            </i>{formErrors.header}
                                        </b>
                                    </Form.Control.Feedback>
                                </InputGroup>
                                <span className='mt-2 d-block'>0/250</span>
                            </Form.Group>
                        </Col>

                        <Col xs={12} sm={12} md={12} className={'py-0'}>
                            <Form.Group controlId="formGridSecurity">
                                <label className='my-0'>Body *</label>
                                <InputGroup>
                                    <FormControl className='pl-3 rounded'
                                                 as="textarea"
                                                 placeholder="Enter Alert or Notification Text"
                                                 value={createAnnouncement.content}
                                                 name='content'
                                                 onChange={handleOnChange}
                                                 isInvalid={!!formErrors.content}
                                                 style={{
                                                     height:'85px',
                                                     fontSize: '16px',
                                                     fontWeight: 'light',
                                                     fontFamily : 'TD Graphik SemiLight'
                                                 }}
                                    />
                                    <Form.Control.Feedback type={"invalid"}>
                                        <b>
                                            <i className="bi bi-exclamation-circle">
                                            </i>{formErrors.content}
                                        </b>
                                    </Form.Control.Feedback>
                                </InputGroup>
                                <span className='mt-2 d-block'>0/250</span>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Check
                                    inline
                                    label="Alert"
                                    name="notification"
                                    type='radio'
                                    className='mr-8'
                                    value='Alert'
                                    onChange={handleOnChange}
                                    isInvalid={!!formErrors.notification}
                                    checked={createAnnouncement.notification === 'Alert'}
                                    id='alert'
                                />
                                <Form.Check
                                    inline
                                    label="Notification"
                                    name="notification"
                                    type='radio'
                                    className='ml-sm-4'
                                    value='Notification'
                                    onChange={handleOnChange}
                                    isInvalid={!!formErrors.notification}
                                    checked={createAnnouncement.notification === 'Notification'}
                                    id='notification'
                                />
                                {formErrors.notification &&
                                    <Form.Control.Feedback type={"invalid"} style={{display: 'block'}}>
                                    <b>
                                        <i className="bi bi-exclamation-circle">
                                        </i>
                                        {formErrors.notification}
                                    </b>
                                </Form.Control.Feedback>}

                            </Form.Group>
                        </Col>
                        <Col>
                            <Row className='pr-5 pl-5'>
                                <Col md={6}>
                                    <button className="btn btn-block td-btn-secondary-clear my-3" onClick={()=>{
                                        props.setShow(false);
                                        props.setShowCreate(false);
                                    }}>Cancel</button>
                                </Col>
                                <Col md={6}>
                                    <button className="btn btn-block td-btn-primary-light my-3">Submit</button>
                                </Col>
                            </Row>
                        </Col>
                    </Form>
                </Container>
    </Modal>
}